module.exports = __webpack_public_path__ + "img/sv87on.e8a52577.svg";